import request from "./request";
import createNotesAPI from "../utils/createNotesAPI";

export const createPickup = (values) =>
  request({ url: `/pickups`, data: values, method: "post" });

export const getPickups = (query) =>
  request({ url: `/pickups`, params: query });

export const updatePickup = (id, values) =>
  request({ url: `/pickups/${id}`, method: "put", data: values });

export const createPickupImage = (id, image) => {
  const data = new FormData();
  data.append("image", image);
  return request({
    url: `/pickups/${id}/images`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPickupImages = (id) =>
  request({ url: `/pickups/${id}/images` });

export const removePickupImage = (id, imageId) =>
  request({ url: `/pickups/${id}/images/${imageId}`, method: "delete" });

export const pickupsNotesAPI = createNotesAPI((id) => `/pickups/${id}/notes`);
